<template>
  <v-container grid-list-lg fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-layout row wrap justify-start>
              <v-flex shrink>
                <v-avatar tile size="128">
                  <img
                    class="br-50"
                    v-if="currentUser.imageUrl"
                    :src="currentUser.imageUrl"
                    alt="User"
                  />
                  <img class="br-50" v-else src="../../../assets/images/user.jpeg" alt="User" />
                </v-avatar>
              </v-flex>
              <v-flex class="ml-2">
                <v-layout column>
                  <v-flex class="display-1 font-weight-medium">{{ currentUser.fullName }}</v-flex>
                  <v-flex>{{ currentUser.loginEmail }}</v-flex>
                  <v-flex class="pt-0">{{ currentUser.AccountType.accountTypeName }}</v-flex>
                </v-layout>
              </v-flex>
              <v-flex shrink >
                 <TaskByDay title="Yours Average Completion" :self="true" />
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 v-if="currentUser.accountTypeID !== 5">
        <TaskCountByDay />
      </v-flex>
      <v-flex xs12 sm12 :md6="currentUser.accountTypeID !== 5">
        <v-layout column>
          <v-flex>
            <v-card dark>
              <v-card-text>
                <TaskByDay title="All User Average Completion" :self="false" />
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex>
            <TodayTasks />
          </v-flex>
          <v-flex v-if="currentUser.accountTypeID !== 5">
            <TaskByEmployee />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm12 md6 v-if="currentUser.accountTypeID !== 5">
        <Tasks />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import TodayTasks from "../components/TodayTasks";
import MyTask from "../components/MyTask";
import Tasks from "../components/Tasks";
import TaskByEmployee from "../components/TaskByEmployee";
import TaskCountByDay from "../components/TaskCountByDay";
import TaskByDay from "../components/TaskByDay"
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      createDialog: false
    };
  },
  computed: {
    ...mapGetters("global", ["currentUser"])
  },
  components: {
    TaskByEmployee,
    MyTask,
    TaskByDay,
    Tasks,
    TodayTasks,
    TaskCountByDay
  },
  created() {
    console.log("currentUser", this.currentUser);
  },
  methods: {
    close() {
      this.createDialog = !this.createDialog;
    },
    add() {
      this.createDialog = !this.createDialog;
    }
  }
};
</script>

<style scoped></style>
